import Text from "../../../../components/ui/Text";
import { ChannelType, useTalkieWalkie } from "../../hooks/use-talkie-walkie";
import Channel from "./Channel";

interface Props {
  className?: string;
  title: string;
  onChannelSelect: (channel: ChannelType) => void;
}

const Channels = ({
  className = "",
  title = "Channels",
  onChannelSelect,
}: Props) => {
  const { channels } = useTalkieWalkie();

  return (
    <div className={` ${className}`}>
      {" "}
      <Text className="text-center text-[#BEB9FF] !font-[400]" size="xs">
        {title}
      </Text>
      <ul className="overflow-y-scroll scrollbar-hide h-[150px] space-y-3 mt-2">
        {channels?.map((channel) => (
          <li key={channel.id}>
            <Channel channel={channel} onChannelSelect={onChannelSelect} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Channels;
